import { normalizeGeometry } from '../util';

module.exports = object => {
    // console.log( object );
    // object = object.children[ 0 ];
    // object.geometry = normalizeGeometry( object.geometry );
    // object.geometry.center();
    // return new THREE.Mesh( object.geometry );
}


// WEBPACK FOOTER //
// ./bin/plugins/FBX.js